import { useQuery } from '@tanstack/react-query'
import { uniqueId } from 'lodash-es'
import { useCallback } from 'react'
import { useUpdateEffect } from 'react-use'
import { scrollToTop } from '../dom'
import queryClient from '../queryClient'

export function getActionQueryOptionsKey(tab: string) {
	return ['ACTION_KEY', tab]
}
export function getActionQueryOptions(tab: string) {
	return {
		queryKey: getActionQueryOptionsKey(tab),
		initialData: uniqueId(),
	}
}
export default function useTabClickListener(tab: string, action: () => any) {
	const { data: refreshKey } = useQuery(getActionQueryOptions(tab))

	useUpdateEffect(() => {
		if (!scrollToTop()) {
			action()
		}
	}, [refreshKey])
}

export function useTabClickNotifyer() {
	return useCallback((tab: string) => {
		queryClient.setQueryData(getActionQueryOptionsKey(tab), uniqueId())
	}, [])
}
